module.exports = __webpack_public_path__ + "static/media/memories_1.a90630a3.jpg";